'use strict';

var enumerate = require('../enumerate');

module.exports = enumerate([
  'CONFIGURATION_REQUEST'
], 'bus:');



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/~/braintree-web/lib/bus/events.js
// module id = 822
// module chunks = 0